import { observer } from 'mobx-react-lite';
import React, { useEffect, useRef, useState } from 'react';
import { CloudDoneOutline, Sync } from 'react-ionicons';
import { useCartContext } from 'screens/AccessExpressV3/CartProvider';

const SyncLoading = observer(() => {
  const cart = useCartContext();

  const [showSavedMessage, setShowSavedMessage] = useState(false);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  // Track previous loading state
  const prevLoadingRef = useRef({
    loadingDraftQuote: cart.loadingDraftQuote,
  });

  useEffect(() => {
    const wasLoading = prevLoadingRef.current.loadingDraftQuote;

    const isNowLoaded = !cart.loadingDraftQuote;

    if (wasLoading && isNowLoaded && cart.resumeOrder?.id) {
      setShowSavedMessage(true);
      timeoutRef.current = setTimeout(() => {
        setShowSavedMessage(false);
      }, 4000);
    }

    // Update previous values
    prevLoadingRef.current = {
      loadingDraftQuote: cart.loadingDraftQuote,
    };

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [cart.loadingDraftQuote, cart.resumeOrder?.id]);

  if (!cart.resumeOrder?.id) return null;

  if (cart.loadingDraftQuote) {
    return (
      <div className="flex gap-2 text-xs font-bold text-content-accent-alt">
        <span className="animate-spin">
          <Sync width="16px" height="16px" color="currentColor" />
        </span>
        Saving draft...
      </div>
    );
  }

  if (showSavedMessage) {
    return (
      <div className="flex gap-2 text-xs font-bold text-content-accent-alt">
        <CloudDoneOutline width="16px" height="16px" color="currentColor" />
        Draft saved
      </div>
    );
  }

  return null;
});

export default SyncLoading;
